import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import useAppBar from 'components/AppBar/useAppBar';
import AutoScale from './components/AutoScale';
import Transition from './components/Transition';

const portraitPaper = {maxWidth:"210mm", maxHeight:"297mm"};
const landscapePaper = {maxWidth:"297mm", maxHeight:"210mm"};

function getPaperStyle(orientation){
  return orientation === 'portrait' ?
    portraitPaper : landscapePaper;
}

const portraitContent = {width:"210mm", height:"297mm"};
const landscapeContent = {width:"297mm", height:"210mm"};

function getContentStyle(orientation){
  return orientation === 'portrait' ?
    portraitContent : landscapeContent;
}


const useStyles = makeStyles(theme => (
  {
    container: {
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2, 2 , 0, 2),
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3, 2, 0, 2),
      },
      position: 'relative',
      overflow: 'hidden',
      boxSizing: 'content-box'
    },
    paper: {
      marginBottom: theme.spacing(2),
      margin: "auto",
      padding: '1.5vh 1.5vw',
    },
    borderTest: {
      border:"1px solid red" 
    }
  }));

const Document = (props) => {
  const classes = useStyles();
  const {
    data
  }= props;
  
  const {
      name,
      pages,
  } = data || {};

  useAppBar(name, props.appBarButtons);

  return (
    <div className={classes.container}>
      {
        pages ? pages.map((page) => {
          const key = `${data.id}-${data.contentId}-${page.pageNo}`;
          return (
          <Transition key={key} in={true}>
            <Paper key={key} className={classes.paper} style={getPaperStyle(page.orientation)}>
              <AutoScale>
                <div dangerouslySetInnerHTML={{ __html: page.html }} 
                    className={classes.content} 
                    style={getContentStyle(page.orientation)}/>
              </AutoScale>
            </Paper>
          </Transition>)
        }) : null
      }
    </div>
  );
}

export default Document;